export const GET_GIFTS_BY_USER = "GET_GIFTS_BY_USER"
export const GET_GIFTS_BY_USER_REQUEST = "GET_GIFTS_BY_USER_REQUEST"
export const GET_GIFTS_BY_USER_SUCCESS = "GET_GIFTS_BY_USER_SUCCESS"
export const GET_GIFTS_BY_USER_ERROR = "GET_GIFTS_BY_USER_ERROR"
export const REDEEM_GIFT = "REDEEM_GIFT"
export const REDEEM_GIFT_REQUEST = "REDEEM_GIFT_REQUEST"
export const REDEEM_GIFT_SUCCESS = "REDEEM_GIFT_SUCCESS"
export const REDEEM_GIFT_ERROR = "REDEEM_GIFT_ERROR"
export const NOT_FOUND_GIFT_FOR_REDEEM = "NOT_FOUND_GIFT_FOR_REDEEM"